<template>
  <div
    class="snackbar__wrapper"
    :class="snackbarWrapperClass"
    v-show="snackBarConfiguration?.show"
  >
    <font-awesome-icon
      v-if="snackBarConfiguration?.icon"
      :icon="snackBarConfiguration?.icon.icon"
      class="snackbar__icon"
      :class="snackBarConfiguration?.icon.color"
    />
    <div class="message__wrapper" :class="messageWrapperClass">
      <span v-if="snackBarConfiguration?.title" class="message--title">
        {{ snackBarConfiguration?.title }}
      </span>
      <span v-if="snackBarConfiguration?.message" class="message">
        {{ snackBarConfiguration?.message }}
      </span>
      <span v-if="snackBarConfiguration?.link">
        <router-link :to="snackBarConfiguration?.link.to">
          <div class="message--link">
            <p>{{ snackBarConfiguration?.link.text }}</p>
          </div>
        </router-link>
      </span>
    </div>
    <span
      v-if="snackBarConfiguration?.action"
      class="message--action"
      @click="snackBarConfiguration?.action.action"
    >
      {{ snackBarConfiguration?.action.text }}
    </span>
    <div
      class="divider"
      v-if="snackBarConfiguration?.action && snackBarConfiguration?.closeable"
    ></div>
    <div class="close-icon__wrapper" v-if="snackBarConfiguration?.closeable">
      <font-awesome-icon
        @click="closeSnackBar"
        :icon="['fas', 'xmark']"
        class="close-icon"
      />
    </div>
  </div>
</template>
<script lang="ts">
const POSITION_CLASS_MAP = {
  'bottom-center': 'snackbar--bottom-center',
  'bottom-left': 'snackbar--bottom-left',
} as const

import { defineComponent, ref, watch, computed } from 'vue'
import { snackBarStore } from '@/store/pinia/snackBar'
import { SnackBar as SnackBarType } from '@/types'

export default defineComponent({
  name: 'AppSnackBar',
  setup() {
    const snackBar = snackBarStore()
    let timeout: any
    const snackBarConfiguration = ref<SnackBarType>()
    const closeSnackBar = () => {
      clearTimeout(timeout)
      snackBar.hideSnackBar()
      snackBarConfiguration.value = { show: false }
    }
    const snackbarWrapperClass = computed(() => {
      const position = snackBarConfiguration.value?.position || 'bottom-left'

      return POSITION_CLASS_MAP[position]
    })
    const messageWrapperClass = computed(() =>
      !!snackBarConfiguration.value?.message ? 'flex-col gap-2' : 'gap-1'
    )

    watch(snackBar.snackBarArray, () => {
      if (snackBar.getSnackBar) {
        snackBarConfiguration.value = snackBar.getSnackBar
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          snackBar.hideSnackBar()
          snackBarConfiguration.value = { show: false }
        }, 5000)
      }
    })

    return {
      snackBarConfiguration,
      closeSnackBar,
      snackbarWrapperClass,
      messageWrapperClass,
    }
  },
})
</script>
<style lang="postcss" scoped>
.divider {
  @apply w-px h-5 bg-jsNeutral-40;
}
.message {
  @apply text-white text-sm;
  &__wrapper {
    @apply flex-grow flex self-start items-center;
  }
  &--title {
    @apply text-white text-sm font-semibold;
  }
  &--action {
    @apply cursor-pointer text-jsBlue-40 capitalize
      text-sm font-semibold self-start;
  }
  &--link {
    @apply text-jsBlue-20 text-sm flex;
  }
}
.close-icon {
  @apply cursor-pointer text-white self-start;
  &__wrapper {
    @apply flex items-center justify-center self-start mt-0.5;
  }
}
.snackbar {
  &__wrapper {
    @apply bg-jsBlue-90 fixed py-3 px-5 rounded-md flex items-center justify-between gap-2 z-topLayer;
  }
  &--bottom-left {
    @apply left-6 bottom-8 self-start;
  }
  &--bottom-center {
    @apply left-1/2 bottom-8 -translate-x-1/2 self-center;
  }
  &__icon {
    @apply mt-0.5;
  }
}
</style>
